import {API_HOST_NAME} from "../../constants.js";
import useAuthenticatedResources from "../../../../useAuthenticatedResources.js";

const useServiceVolumesResources = (teamId, projectId, serviceId) => {
  const url = `${API_HOST_NAME}/api/v1/admin/teams/${teamId}/docker/projects/${projectId}/services/${serviceId}/volumes`;
  return useAuthenticatedResources(url)
}

export default useServiceVolumesResources;
